import * as React from 'react';
/**
 *
 * Original name: emoji sunglasses
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A350
 *
 */
export const EmojiSunglassesPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M32 8C16.523 8 8 16.523 8 32s8.523 24 24 24 24-8.523 24-24S47.477 8 32 8Zm0 44c-13.271 0-20-6.729-20-20s6.729-20 20-20 20 6.729 20 20-6.729 20-20 20Z", fill: "currentColor" }),
    React.createElement("path", { d: "M41 20c-3.061 0-5.4 1.377-6.426 3.877a6.964 6.964 0 0 0-5.147 0C28.4 21.377 26.061 20 23 20c-4.163 0-7 2.539-7 7s2.837 7 7 7a6.635 6.635 0 0 0 5.984-3H29v-.028c.49-.84.8-1.77.914-2.735a2.976 2.976 0 0 1 4.173 0c.113.965.424 1.896.913 2.735V31h.016A6.635 6.635 0 0 0 41 34c4.163 0 7-2.539 7-7s-2.837-7-7-7Zm-5 21h-7v4h7a8.009 8.009 0 0 0 8-8h-4a4 4 0 0 1-4 4Z", fill: "currentColor" })));
